import React from "react";
import {PermanentMenu, PermanentMenuHeader} from "@bounce/shared/ui";

import {useSpringMenuItems} from "./menu-items";
import {urls} from "../../routes/urls";
import {useAuth} from "contexts";
import {useNavigate} from "react-router-dom";
import {useGetResolutionExpertByEmail} from "../../apis/requests/backoffice/spring-users-management/getReFullName";
import {queryClient} from "@bounce/shared/requests";

const SpringMenu = () => {
  const {agentEmail} = useAuth();
  const navigate = useNavigate();
  const {data, isLoading} = useGetResolutionExpertByEmail({agentEmail});
  const springMenuItems = useSpringMenuItems();

  const onSignOut = () => {
    localStorage.clear();
    queryClient.invalidateQueries();
    navigate(urls.backofficeLogin.url);
  };

  const onHomeClick = () => {
    navigate(urls.spring.url);
  };

  return (
    <PermanentMenu
      menuItems={springMenuItems}
      header={
        <PermanentMenuHeader
          platform="spring"
          fullName={data?.full_name}
          email={agentEmail}
          isLoading={isLoading}
          onSignOut={onSignOut}
          onHomeClick={onHomeClick}
        />
      }
      platform="spring"
    />
  );
};
export default SpringMenu;
